import { camelCaseKeys } from '../util/object';

const reportTemplateDefaultListRaw = [
  {
    report_template: {
      template_id: 1,
      report_name: 'Standard Report',
      ventura_contract_ids: [],
      include_header: true,
      include_footer: true,
      include_logo: true,
      include_glossary: true,
      sheet_objects: [
        {
          sheet_name: 'Summary',
          report_sections: [
            {
              section_name: 'Campaign Basics',
              section_type: 'First Party',
              partition_by_io: false,
              include_subtotals: false,
              columns: [
                'contract_name',
                'contract_start_date',
                'contract_end_date',
                'contract_days_left',
                'contract_imp_budget',
                'contract_dollar_budget',
              ],
              column_labels: null,
              sort_by: null,
              sort_ascending: null,
            },
            {
              section_name: 'Media Basics',
              section_type: 'Media Type',
              partition_by_io: false,
              include_subtotals: false,
              columns: [
                'media_type',
                'pricing_model',
                'pricing_rate',
                'total_impression_budget',
                'total_dollar_budget',
              ],
              column_labels: null,
              sort_by: null,
              sort_ascending: null,
            },
            {
              section_name: 'Delivery (Campaign Totals)',
              section_type: 'First Party',
              partition_by_io: false,
              include_subtotals: false,
              columns: [
                'impressions',
                'clicks',
                'ctr',
                'investment_to_date',
                'delivery_percent',
                'remaining_impressions',
                'remaining_budget',
              ],
              column_labels: null,
              sort_by: null,
              sort_ascending: null,
            },
            {
              section_name: 'Delivery (Media Type)',
              section_type: 'Media Type',
              partition_by_io: false,
              include_subtotals: false,
              columns: [
                'media_type',
                'impressions',
                'clicks',
                'ctr',
                'investment_to_date',
                'delivery_percent',
                'remaining_impressions',
                'remaining_budget',
              ],
              column_labels: null,
              sort_by: null,
              sort_ascending: null,
            },
            {
              section_name: 'Campaign Monthly Totals',
              section_type: 'First Party',
              partition_by_io: false,
              include_subtotals: true,
              columns: ['report_month', 'investment_to_date', 'impressions', 'clicks', 'ctr', 'delivery_percent'],
              column_labels: null,
              sort_by: null,
              sort_ascending: null,
            },
          ],
        },
        {
          sheet_name: 'Monthly Performance',
          report_sections: [
            {
              section_name: 'Line Item Totals',
              section_type: 'First Party',
              partition_by_io: false,
              include_subtotals: true,
              columns: [
                'io_name',
                'media_type',
                'io_start_date',
                'io_end_date',
                'io_days_left',
                'io_imp_budget',
                'io_dollar_budget',
                'pricing_model',
                'adjusted_pricing_rate',
                'investment_to_date',
                'impressions',
                'clicks',
                'ctr',
                'delivery_percent',
                'remaining_impressions',
                'remaining_budget',
              ],
              column_labels: null,
              sort_by: null,
              sort_ascending: null,
            },
            {
              section_name: 'Line Item Monthly Totals',
              section_type: 'First Party',
              partition_by_io: true,
              include_subtotals: true,
              columns: [
                'io_name',
                'media_type',
                'report_month',
                'investment_to_date',
                'impressions',
                'clicks',
                'ctr',
                'delivery_percent',
              ],
              column_labels: null,
              sort_by: null,
              sort_ascending: null,
            },
          ],
        },
        {
          sheet_name: 'Daily Performance',
          report_sections: [
            {
              section_name: 'Line Item Totals',
              section_type: 'First Party',
              partition_by_io: false,
              include_subtotals: true,
              columns: [
                'io_name',
                'media_type',
                'io_start_date',
                'io_end_date',
                'io_days_left',
                'io_imp_budget',
                'io_dollar_budget',
                'pricing_model',
                'adjusted_pricing_rate',
                'investment_to_date',
                'impressions',
                'clicks',
                'ctr',
                'delivery_percent',
                'remaining_impressions',
                'remaining_budget',
              ],
              column_labels: null,
              sort_by: null,
              sort_ascending: null,
            },
            {
              section_name: 'Line Item Daily Totals',
              section_type: 'First Party',
              partition_by_io: true,
              include_subtotals: true,
              columns: [
                'io_name',
                'media_type',
                'report_day',
                'investment_to_date',
                'impressions',
                'clicks',
                'ctr',
                'delivery_percent',
              ],
              column_labels: null,
              sort_by: null,
              sort_ascending: null,
            },
          ],
        },
        {
          sheet_name: 'Creatives',
          report_sections: [
            {
              section_name: 'Creative Totals',
              section_type: 'First Party',
              partition_by_io: false,
              include_subtotals: true,
              columns: ['creative_name', 'creative_size', 'investment_to_date', 'impressions', 'clicks', 'ctr'],
              column_labels: null,
              sort_by: null,
              sort_ascending: null,
            },
            {
              section_name: 'Creative Totals by Line Item',
              section_type: 'First Party',
              partition_by_io: true,
              include_subtotals: true,
              columns: [
                'io_name',
                'media_type',
                'creative_name',
                'creative_size',
                'investment_to_date',
                'impressions',
                'clicks',
                'ctr',
              ],
              column_labels: null,
              sort_by: null,
              sort_ascending: null,
            },
          ],
        },
      ],
    },
  },
  {
    report_template: {
      template_id: 2,
      report_name: 'Standard Report (DCM)',
      ventura_contract_ids: [],
      include_header: true,
      include_footer: true,
      include_logo: true,
      include_glossary: true,
      sheet_objects: [
        {
          sheet_name: 'Summary',
          report_sections: [
            {
              section_name: 'Campaign Basics',
              section_type: 'First Party',
              partition_by_io: false,
              include_subtotals: false,
              columns: [
                'contract_name',
                'contract_start_date',
                'contract_end_date',
                'contract_days_left',
                'contract_imp_budget',
                'contract_dollar_budget',
              ],
              column_labels: null,
              sort_by: null,
              sort_ascending: null,
            },
            {
              section_name: 'Media Basics',
              section_type: 'Media Type',
              partition_by_io: false,
              include_subtotals: false,
              columns: [
                'media_type',
                'pricing_model',
                'pricing_rate',
                'total_impression_budget',
                'total_dollar_budget',
              ],
              column_labels: null,
              sort_by: null,
              sort_ascending: null,
            },
            {
              section_name: 'Delivery (Campaign Totals)',
              section_type: 'Third Party',
              partition_by_io: false,
              include_subtotals: false,
              columns: [
                'impressions',
                'clicks',
                'ctr',
                'investment_to_date',
                'delivery_percent',
                'remaining_impressions',
                'remaining_budget',
                'dcm_impressions',
                'dcm_clicks',
                'dcm_ctr',
                'dcm_discrepancy',
              ],
              column_labels: null,
              sort_by: null,
              sort_ascending: null,
            },
            {
              section_name: 'Delivery (Media Type)',
              section_type: 'Media Type',
              partition_by_io: false,
              include_subtotals: false,
              columns: [
                'media_type',
                'impressions',
                'clicks',
                'ctr',
                'investment_to_date',
                'delivery_percent',
                'remaining_impressions',
                'remaining_budget',
                'dcm_impressions',
                'dcm_clicks',
                'dcm_ctr',
                'dcm_discrepancy',
              ],
              column_labels: null,
              sort_by: null,
              sort_ascending: null,
            },
            {
              section_name: 'Campaign Monthly Totals',
              section_type: 'Third Party',
              partition_by_io: false,
              include_subtotals: true,
              columns: [
                'report_month',
                'investment_to_date',
                'impressions',
                'clicks',
                'ctr',
                'delivery_percent',
                'dcm_impressions',
                'dcm_clicks',
                'dcm_ctr',
                'dcm_discrepancy',
              ],
              column_labels: null,
              sort_by: null,
              sort_ascending: null,
            },
          ],
        },
        {
          sheet_name: 'Monthly Performance',
          report_sections: [
            {
              section_name: 'Line Item Totals',
              section_type: 'Third Party',
              partition_by_io: false,
              include_subtotals: true,
              columns: [
                'io_name',
                'media_type',
                'io_start_date',
                'io_end_date',
                'io_days_left',
                'io_imp_budget',
                'io_dollar_budget',
                'pricing_model',
                'adjusted_pricing_rate',
                'investment_to_date',
                'impressions',
                'clicks',
                'ctr',
                'delivery_percent',
                'remaining_impressions',
                'remaining_budget',
                'dcm_impressions',
                'dcm_clicks',
                'dcm_ctr',
                'dcm_discrepancy',
              ],
              column_labels: null,
              sort_by: null,
              sort_ascending: null,
            },
            {
              section_name: 'Line Item Monthly Totals',
              section_type: 'Third Party',
              partition_by_io: true,
              include_subtotals: true,
              columns: [
                'io_name',
                'media_type',
                'report_month',
                'investment_to_date',
                'impressions',
                'clicks',
                'ctr',
                'delivery_percent',
                'dcm_impressions',
                'dcm_clicks',
                'dcm_ctr',
                'dcm_discrepancy',
              ],
              column_labels: null,
              sort_by: null,
              sort_ascending: null,
            },
          ],
        },
        {
          sheet_name: 'Daily Performance',
          report_sections: [
            {
              section_name: 'Line Item Totals',
              section_type: 'Third Party',
              partition_by_io: false,
              include_subtotals: true,
              columns: [
                'io_name',
                'media_type',
                'io_start_date',
                'io_end_date',
                'io_days_left',
                'io_imp_budget',
                'io_dollar_budget',
                'pricing_model',
                'adjusted_pricing_rate',
                'investment_to_date',
                'impressions',
                'clicks',
                'ctr',
                'delivery_percent',
                'remaining_impressions',
                'remaining_budget',
                'dcm_impressions',
                'dcm_clicks',
                'dcm_ctr',
                'dcm_discrepancy',
              ],
              column_labels: null,
              sort_by: null,
              sort_ascending: null,
            },
            {
              section_name: 'Line Item Daily Totals',
              section_type: 'Third Party',
              partition_by_io: true,
              include_subtotals: true,
              columns: [
                'io_name',
                'media_type',
                'report_day',
                'investment_to_date',
                'impressions',
                'clicks',
                'ctr',
                'delivery_percent',
                'dcm_impressions',
                'dcm_clicks',
                'dcm_ctr',
                'dcm_discrepancy',
              ],
              column_labels: null,
              sort_by: null,
              sort_ascending: null,
            },
          ],
        },
        {
          sheet_name: 'Creatives',
          report_sections: [
            {
              section_name: 'Creative Totals',
              section_type: 'First Party',
              partition_by_io: false,
              include_subtotals: true,
              columns: ['creative_name', 'creative_size', 'investment_to_date', 'impressions', 'clicks', 'ctr'],
              column_labels: null,
              sort_by: null,
              sort_ascending: null,
            },
            {
              section_name: 'Creative Totals by Line Item',
              section_type: 'First Party',
              partition_by_io: true,
              include_subtotals: true,
              columns: [
                'io_name',
                'media_type',
                'creative_name',
                'creative_size',
                'investment_to_date',
                'impressions',
                'clicks',
                'ctr',
              ],
              column_labels: null,
              sort_by: null,
              sort_ascending: null,
            },
          ],
        },
      ],
    },
  },
  {
    report_template: {
      template_id: 3,
      report_name: 'Geo Report',
      ventura_contract_ids: [],
      include_header: true,
      include_footer: true,
      include_logo: true,
      include_glossary: true,
      sheet_objects: [
        {
          sheet_name: 'Summary',
          report_sections: [
            {
              section_name: 'Campaign Basics',
              section_type: 'First Party',
              partition_by_io: false,
              include_subtotals: false,
              columns: [
                'contract_name',
                'contract_start_date',
                'contract_end_date',
                'contract_days_left',
                'contract_imp_budget',
                'contract_dollar_budget',
              ],
              column_labels: null,
              sort_by: null,
              sort_ascending: null,
            },
            {
              section_name: 'Media Basics',
              section_type: 'Media Type',
              partition_by_io: false,
              include_subtotals: false,
              columns: [
                'media_type',
                'pricing_model',
                'pricing_rate',
                'total_impression_budget',
                'total_dollar_budget',
              ],
              column_labels: null,
              sort_by: null,
              sort_ascending: null,
            },
            {
              section_name: 'Delivery (Campaign Totals)',
              section_type: 'First Party',
              partition_by_io: false,
              include_subtotals: false,
              columns: [
                'impressions',
                'clicks',
                'ctr',
                'investment_to_date',
                'delivery_percent',
                'remaining_impressions',
                'remaining_budget',
              ],
              column_labels: null,
              sort_by: null,
              sort_ascending: null,
            },
            {
              section_name: 'Delivery (Media Type)',
              section_type: 'Media Type',
              partition_by_io: false,
              include_subtotals: false,
              columns: [
                'media_type',
                'impressions',
                'clicks',
                'ctr',
                'investment_to_date',
                'delivery_percent',
                'remaining_impressions',
                'remaining_budget',
              ],
              column_labels: null,
              sort_by: null,
              sort_ascending: null,
            },
            {
              section_name: 'Campaign Monthly Totals',
              section_type: 'First Party',
              partition_by_io: false,
              include_subtotals: true,
              columns: ['report_month', 'investment_to_date', 'impressions', 'clicks', 'ctr', 'delivery_percent'],
              column_labels: null,
              sort_by: null,
              sort_ascending: null,
            },
          ],
        },
        {
          sheet_name: 'Monthly Performance',
          report_sections: [
            {
              section_name: 'Line Item Totals',
              section_type: 'First Party',
              partition_by_io: false,
              include_subtotals: true,
              columns: [
                'io_name',
                'media_type',
                'io_start_date',
                'io_end_date',
                'io_days_left',
                'io_imp_budget',
                'io_dollar_budget',
                'pricing_model',
                'adjusted_pricing_rate',
                'investment_to_date',
                'impressions',
                'clicks',
                'ctr',
                'delivery_percent',
                'remaining_impressions',
                'remaining_budget',
              ],
              column_labels: null,
              sort_by: null,
              sort_ascending: null,
            },
            {
              section_name: 'Line Item Monthly Totals',
              section_type: 'First Party',
              partition_by_io: true,
              include_subtotals: true,
              columns: [
                'io_name',
                'media_type',
                'report_month',
                'investment_to_date',
                'impressions',
                'clicks',
                'ctr',
                'delivery_percent',
              ],
              column_labels: null,
              sort_by: null,
              sort_ascending: null,
            },
          ],
        },
        {
          sheet_name: 'Daily Performance',
          report_sections: [
            {
              section_name: 'Line Item Totals',
              section_type: 'First Party',
              partition_by_io: false,
              include_subtotals: true,
              columns: [
                'io_name',
                'media_type',
                'io_start_date',
                'io_end_date',
                'io_days_left',
                'io_imp_budget',
                'io_dollar_budget',
                'pricing_model',
                'adjusted_pricing_rate',
                'investment_to_date',
                'impressions',
                'clicks',
                'ctr',
                'delivery_percent',
                'remaining_impressions',
                'remaining_budget',
              ],
              column_labels: null,
              sort_by: null,
              sort_ascending: null,
            },
            {
              section_name: 'Line Item Daily Totals',
              section_type: 'First Party',
              partition_by_io: true,
              include_subtotals: true,
              columns: [
                'io_name',
                'media_type',
                'report_day',
                'investment_to_date',
                'impressions',
                'clicks',
                'ctr',
                'delivery_percent',
              ],
              column_labels: null,
              sort_by: null,
              sort_ascending: null,
            },
          ],
        },
        {
          sheet_name: 'Creatives',
          report_sections: [
            {
              section_name: 'Creative Totals',
              section_type: 'First Party',
              partition_by_io: false,
              include_subtotals: true,
              columns: ['creative_name', 'creative_size', 'investment_to_date', 'impressions', 'clicks', 'ctr'],
              column_labels: null,
              sort_by: null,
              sort_ascending: null,
            },
            {
              section_name: 'Creative Totals by Line Item',
              section_type: 'First Party',
              partition_by_io: true,
              include_subtotals: true,
              columns: [
                'io_name',
                'media_type',
                'creative_name',
                'creative_size',
                'investment_to_date',
                'impressions',
                'clicks',
                'ctr',
              ],
              column_labels: null,
              sort_by: null,
              sort_ascending: null,
            },
          ],
        },
        {
          sheet_name: 'Locations',
          report_sections: [
            {
              section_name: 'Location Totals',
              section_type: 'Location',
              partition_by_io: false,
              include_subtotals: true,
              columns: ['location_name', 'investment_to_date', 'impressions', 'clicks', 'ctr'],
              column_labels: null,
              sort_by: null,
              sort_ascending: null,
            },
            {
              section_name: 'Location Totals by Line Item',
              section_type: 'Location',
              partition_by_io: true,
              include_subtotals: true,
              columns: ['io_name', 'location_name', 'investment_to_date', 'impressions', 'clicks', 'ctr'],
              column_labels: null,
              sort_by: null,
              sort_ascending: null,
            },
          ],
        },
        {
          sheet_name: 'States',
          report_sections: [
            {
              section_name: 'State Totals',
              section_type: 'Location',
              partition_by_io: false,
              include_subtotals: true,
              columns: ['state_name', 'investment_to_date', 'impressions', 'clicks', 'ctr'],
              column_labels: null,
              sort_by: null,
              sort_ascending: null,
            },
            {
              section_name: 'State Totals by Line Item',
              section_type: 'Location',
              partition_by_io: true,
              include_subtotals: true,
              columns: ['io_name', 'state_name', 'investment_to_date', 'impressions', 'clicks', 'ctr'],
              column_labels: null,
              sort_by: null,
              sort_ascending: null,
            },
          ],
        },
        {
          sheet_name: 'Cities',
          report_sections: [
            {
              section_name: 'City Totals',
              section_type: 'Location',
              partition_by_io: false,
              include_subtotals: true,
              columns: ['state_name', 'city_name', 'investment_to_date', 'impressions', 'clicks', 'ctr'],
              column_labels: null,
              sort_by: null,
              sort_ascending: null,
            },
            {
              section_name: 'City Totals by Line Item',
              section_type: 'Location',
              partition_by_io: true,
              include_subtotals: true,
              columns: ['io_name', 'state_name', 'city_name', 'investment_to_date', 'impressions', 'clicks', 'ctr'],
              column_labels: null,
              sort_by: null,
              sort_ascending: null,
            },
          ],
        },
        {
          sheet_name: 'Postal Codes',
          report_sections: [
            {
              section_name: 'Postal Code Totals',
              section_type: 'Location',
              partition_by_io: false,
              include_subtotals: true,
              columns: ['postal_code', 'investment_to_date', 'impressions', 'clicks', 'ctr'],
              column_labels: null,
              sort_by: null,
              sort_ascending: null,
            },
            {
              section_name: 'Postal Code Totals by Line Item',
              section_type: 'Location',
              partition_by_io: true,
              include_subtotals: true,
              columns: ['io_name', 'postal_code', 'investment_to_date', 'impressions', 'clicks', 'ctr'],
              column_labels: null,
              sort_by: null,
              sort_ascending: null,
            },
          ],
        },
        {
          sheet_name: 'Nielsen DMAs',
          report_sections: [
            {
              section_name: 'Nielsen DMA Totals',
              section_type: 'Location',
              partition_by_io: false,
              include_subtotals: true,
              columns: ['dma_name', 'investment_to_date', 'impressions', 'clicks', 'ctr'],
              column_labels: null,
              sort_by: null,
              sort_ascending: null,
            },
            {
              section_name: 'Nielsen DMA Totals by Line Item',
              section_type: 'Location',
              partition_by_io: true,
              include_subtotals: true,
              columns: ['io_name', 'dma_name', 'investment_to_date', 'impressions', 'clicks', 'ctr'],
              column_labels: null,
              sort_by: null,
              sort_ascending: null,
            },
          ],
        },
      ],
    },
  },

  {
    report_template: {
      template_id: 4,
      report_name: 'Geo Report (DCM)',
      ventura_contract_ids: [],
      include_header: true,
      include_footer: true,
      include_logo: true,
      include_glossary: true,
      sheet_objects: [
        {
          sheet_name: 'Summary',
          report_sections: [
            {
              section_name: 'Campaign Basics',
              section_type: 'First Party',
              partition_by_io: false,
              include_subtotals: false,
              columns: [
                'contract_name',
                'contract_start_date',
                'contract_end_date',
                'contract_days_left',
                'contract_imp_budget',
                'contract_dollar_budget',
              ],
              column_labels: null,
              sort_by: null,
              sort_ascending: null,
            },
            {
              section_name: 'Media Basics',
              section_type: 'Media Type',
              partition_by_io: false,
              include_subtotals: false,
              columns: [
                'media_type',
                'pricing_model',
                'pricing_rate',
                'total_impression_budget',
                'total_dollar_budget',
              ],
              column_labels: null,
              sort_by: null,
              sort_ascending: null,
            },
            {
              section_name: 'Delivery (Campaign Totals)',
              section_type: 'Third Party',
              partition_by_io: false,
              include_subtotals: false,
              columns: [
                'impressions',
                'clicks',
                'ctr',
                'investment_to_date',
                'delivery_percent',
                'remaining_impressions',
                'remaining_budget',
                'dcm_impressions',
                'dcm_clicks',
                'dcm_ctr',
                'dcm_discrepancy',
              ],
              column_labels: null,
              sort_by: null,
              sort_ascending: null,
            },
            {
              section_name: 'Delivery (Media Type)',
              section_type: 'Media Type',
              partition_by_io: false,
              include_subtotals: false,
              columns: [
                'media_type',
                'impressions',
                'clicks',
                'ctr',
                'investment_to_date',
                'delivery_percent',
                'remaining_impressions',
                'remaining_budget',
                'dcm_impressions',
                'dcm_clicks',
                'dcm_ctr',
                'dcm_discrepancy',
              ],
              column_labels: null,
              sort_by: null,
              sort_ascending: null,
            },
            {
              section_name: 'Campaign Monthly Totals',
              section_type: 'Third Party',
              partition_by_io: false,
              include_subtotals: true,
              columns: [
                'report_month',
                'investment_to_date',
                'impressions',
                'clicks',
                'ctr',
                'delivery_percent',
                'dcm_impressions',
                'dcm_clicks',
                'dcm_ctr',
                'dcm_discrepancy',
              ],
              column_labels: null,
              sort_by: null,
              sort_ascending: null,
            },
          ],
        },
        {
          sheet_name: 'Monthly Performance',
          report_sections: [
            {
              section_name: 'Line Item Totals',
              section_type: 'Third Party',
              partition_by_io: false,
              include_subtotals: true,
              columns: [
                'io_name',
                'media_type',
                'io_start_date',
                'io_end_date',
                'io_days_left',
                'io_imp_budget',
                'io_dollar_budget',
                'pricing_model',
                'adjusted_pricing_rate',
                'investment_to_date',
                'impressions',
                'clicks',
                'ctr',
                'delivery_percent',
                'remaining_impressions',
                'remaining_budget',
                'dcm_impressions',
                'dcm_clicks',
                'dcm_ctr',
                'dcm_discrepancy',
              ],
              column_labels: null,
              sort_by: null,
              sort_ascending: null,
            },
            {
              section_name: 'Line Item Monthly Totals',
              section_type: 'Third Party',
              partition_by_io: true,
              include_subtotals: true,
              columns: [
                'io_name',
                'media_type',
                'report_month',
                'investment_to_date',
                'impressions',
                'clicks',
                'ctr',
                'delivery_percent',
                'dcm_impressions',
                'dcm_clicks',
                'dcm_ctr',
                'dcm_discrepancy',
              ],
              column_labels: null,
              sort_by: null,
              sort_ascending: null,
            },
          ],
        },
        {
          sheet_name: 'Daily Performance',
          report_sections: [
            {
              section_name: 'Line Item Totals',
              section_type: 'Third Party',
              partition_by_io: false,
              include_subtotals: true,
              columns: [
                'io_name',
                'media_type',
                'io_start_date',
                'io_end_date',
                'io_days_left',
                'io_imp_budget',
                'io_dollar_budget',
                'pricing_model',
                'adjusted_pricing_rate',
                'investment_to_date',
                'impressions',
                'clicks',
                'ctr',
                'delivery_percent',
                'remaining_impressions',
                'remaining_budget',
                'dcm_impressions',
                'dcm_clicks',
                'dcm_ctr',
                'dcm_discrepancy',
              ],
              column_labels: null,
              sort_by: null,
              sort_ascending: null,
            },
            {
              section_name: 'Line Item Daily Totals',
              section_type: 'Third Party',
              partition_by_io: true,
              include_subtotals: true,
              columns: [
                'io_name',
                'media_type',
                'report_day',
                'investment_to_date',
                'impressions',
                'clicks',
                'ctr',
                'delivery_percent',
                'dcm_impressions',
                'dcm_clicks',
                'dcm_ctr',
                'dcm_discrepancy',
              ],
              column_labels: null,
              sort_by: null,
              sort_ascending: null,
            },
          ],
        },
        {
          sheet_name: 'Creatives',
          report_sections: [
            {
              section_name: 'Creative Totals',
              section_type: 'First Party',
              partition_by_io: false,
              include_subtotals: true,
              columns: ['creative_name', 'creative_size', 'investment_to_date', 'impressions', 'clicks', 'ctr'],
              column_labels: null,
              sort_by: null,
              sort_ascending: null,
            },
            {
              section_name: 'Creative Totals by Line Item',
              section_type: 'First Party',
              partition_by_io: true,
              include_subtotals: true,
              columns: [
                'io_name',
                'media_type',
                'creative_name',
                'creative_size',
                'investment_to_date',
                'impressions',
                'clicks',
                'ctr',
              ],
              column_labels: null,
              sort_by: null,
              sort_ascending: null,
            },
          ],
        },
        {
          sheet_name: 'Locations',
          report_sections: [
            {
              section_name: 'Location Totals',
              section_type: 'Location',
              partition_by_io: false,
              include_subtotals: true,
              columns: ['location_name', 'investment_to_date', 'impressions', 'clicks', 'ctr'],
              column_labels: null,
              sort_by: null,
              sort_ascending: null,
            },
            {
              section_name: 'Location Totals by Line Item',
              section_type: 'Location',
              partition_by_io: true,
              include_subtotals: true,
              columns: ['io_name', 'location_name', 'investment_to_date', 'impressions', 'clicks', 'ctr'],
              column_labels: null,
              sort_by: null,
              sort_ascending: null,
            },
          ],
        },
        {
          sheet_name: 'States',
          report_sections: [
            {
              section_name: 'State Totals',
              section_type: 'Location',
              partition_by_io: false,
              include_subtotals: true,
              columns: ['state_name', 'investment_to_date', 'impressions', 'clicks', 'ctr'],
              column_labels: null,
              sort_by: null,
              sort_ascending: null,
            },
            {
              section_name: 'State Totals by Line Item',
              section_type: 'Location',
              partition_by_io: true,
              include_subtotals: true,
              columns: ['io_name', 'state_name', 'investment_to_date', 'impressions', 'clicks', 'ctr'],
              column_labels: null,
              sort_by: null,
              sort_ascending: null,
            },
          ],
        },
        {
          sheet_name: 'Cities',
          report_sections: [
            {
              section_name: 'City Totals',
              section_type: 'Location',
              partition_by_io: false,
              include_subtotals: true,
              columns: ['state_name', 'city_name', 'investment_to_date', 'impressions', 'clicks', 'ctr'],
              column_labels: null,
              sort_by: null,
              sort_ascending: null,
            },
            {
              section_name: 'City Totals by Line Item',
              section_type: 'Location',
              partition_by_io: true,
              include_subtotals: true,
              columns: ['io_name', 'state_name', 'city_name', 'investment_to_date', 'impressions', 'clicks', 'ctr'],
              column_labels: null,
              sort_by: null,
              sort_ascending: null,
            },
          ],
        },
        {
          sheet_name: 'Postal Codes',
          report_sections: [
            {
              section_name: 'Postal Code Totals',
              section_type: 'Location',
              partition_by_io: false,
              include_subtotals: true,
              columns: ['postal_code', 'investment_to_date', 'impressions', 'clicks', 'ctr'],
              column_labels: null,
              sort_by: null,
              sort_ascending: null,
            },
            {
              section_name: 'Postal Code Totals by Line Item',
              section_type: 'Location',
              partition_by_io: true,
              include_subtotals: true,
              columns: ['io_name', 'postal_code', 'investment_to_date', 'impressions', 'clicks', 'ctr'],
              column_labels: null,
              sort_by: null,
              sort_ascending: null,
            },
          ],
        },
        {
          sheet_name: 'Nielsen DMAs',
          report_sections: [
            {
              section_name: 'Nielsen DMA Totals',
              section_type: 'Location',
              partition_by_io: false,
              include_subtotals: true,
              columns: ['dma_name', 'investment_to_date', 'impressions', 'clicks', 'ctr'],
              column_labels: null,
              sort_by: null,
              sort_ascending: null,
            },
            {
              section_name: 'Nielsen DMA Totals by Line Item',
              section_type: 'Location',
              partition_by_io: true,
              include_subtotals: true,
              columns: ['io_name', 'dma_name', 'investment_to_date', 'impressions', 'clicks', 'ctr'],
              column_labels: null,
              sort_by: null,
              sort_ascending: null,
            },
          ],
        },
      ],
    },
  },
  {
    report_template: {
      template_id: 5,
      report_name: 'Standard Report (IAS)',
      ventura_contract_ids: [],
      include_header: true,
      include_footer: true,
      include_logo: true,
      include_glossary: true,
      sheet_objects: [
        {
          sheet_name: 'Summary',
          report_sections: [
            {
              section_name: 'Campaign Basics',
              section_type: 'First Party',
              partition_by_io: false,
              include_subtotals: false,
              columns: [
                'contract_name',
                'contract_start_date',
                'contract_end_date',
                'contract_days_left',
                'contract_imp_budget',
                'contract_dollar_budget',
              ],
              column_labels: null,
              sort_by: null,
              sort_ascending: null,
            },
            {
              section_name: 'Media Basics',
              section_type: 'Media Type',
              partition_by_io: false,
              include_subtotals: false,
              columns: [
                'media_type',
                'pricing_model',
                'pricing_rate',
                'total_impression_budget',
                'total_dollar_budget',
              ],
              column_labels: null,
              sort_by: null,
              sort_ascending: null,
            },
            {
              section_name: 'Delivery (Media Type)',
              section_type: 'Media Type',
              partition_by_io: false,
              include_subtotals: false,
              columns: [
                'media_type',
                'impressions',
                'clicks',
                'ctr',
                'investment_to_date',
                'delivery_percent',
                'remaining_impressions',
                'remaining_budget',
                'ias_total_tracked_ads',
                'ias_eligible_ivt_ads',
                'ias_valid_traffic',
                'ias_ivt_free_rate',
                'ias_measured_ads',
                'ias_viewable_impressions',
                'ias_viewability',
                'ias_passed_ads',
                'ias_eligible_ads_brand_safety',
                'ias_brand_safety_rate',
                'ias_brand_suitability_failed_ads',
                'ias_brand_suitability_rate',
              ],
              column_labels: null,
              sort_by: null,
              sort_ascending: null,
            },
            {
              section_name: 'Campaign Monthly Totals',
              section_type: 'Third Party',
              partition_by_io: false,
              include_subtotals: true,
              columns: [
                'report_month',
                'investment_to_date',
                'impressions',
                'clicks',
                'ctr',
                'delivery_percent',
                'ias_total_tracked_ads',
                'ias_eligible_ivt_ads',
                'ias_valid_traffic',
                'ias_ivt_free_rate',
                'ias_measured_ads',
                'ias_viewable_impressions',
                'ias_viewability',
                'ias_passed_ads',
                'ias_eligible_ads_brand_safety',
                'ias_brand_safety_rate',
                'ias_brand_suitability_failed_ads',
                'ias_brand_suitability_rate',
              ],
              column_labels: null,
              sort_by: null,
              sort_ascending: null,
            },
          ],
        },
        {
          sheet_name: 'Monthly Performance',
          report_sections: [
            {
              section_name: 'Line Item Totals',
              section_type: 'Third Party',
              partition_by_io: false,
              include_subtotals: true,
              columns: [
                'io_name',
                'media_type',
                'io_start_date',
                'io_end_date',
                'io_days_left',
                'io_imp_budget',
                'io_dollar_budget',
                'pricing_model',
                'adjusted_pricing_rate',
                'investment_to_date',
                'impressions',
                'clicks',
                'ctr',
                'delivery_percent',
                'remaining_impressions',
                'remaining_budget',
                'ias_total_tracked_ads',
                'ias_eligible_ivt_ads',
                'ias_valid_traffic',
                'ias_ivt_free_rate',
                'ias_measured_ads',
                'ias_viewable_impressions',
                'ias_viewability',
                'ias_passed_ads',
                'ias_eligible_ads_brand_safety',
                'ias_brand_safety_rate',
                'ias_brand_suitability_failed_ads',
                'ias_brand_suitability_rate',
              ],
              column_labels: null,
              sort_by: null,
              sort_ascending: null,
            },
            {
              section_name: 'Line Item Monthly Totals',
              section_type: 'Third Party',
              partition_by_io: true,
              include_subtotals: true,
              columns: [
                'io_name',
                'media_type',
                'report_month',
                'investment_to_date',
                'impressions',
                'clicks',
                'ctr',
                'delivery_percent',
                'ias_total_tracked_ads',
                'ias_eligible_ivt_ads',
                'ias_valid_traffic',
                'ias_ivt_free_rate',
                'ias_measured_ads',
                'ias_viewable_impressions',
                'ias_viewability',
                'ias_passed_ads',
                'ias_eligible_ads_brand_safety',
                'ias_brand_safety_rate',
                'ias_brand_suitability_failed_ads',
                'ias_brand_suitability_rate',
              ],
              column_labels: null,
              sort_by: null,
              sort_ascending: null,
            },
          ],
        },
        {
          sheet_name: 'Daily Performance',
          report_sections: [
            {
              section_name: 'Line Item Totals',
              section_type: 'Third Party',
              partition_by_io: false,
              include_subtotals: true,
              columns: [
                'io_name',
                'media_type',
                'io_start_date',
                'io_end_date',
                'io_days_left',
                'io_imp_budget',
                'io_dollar_budget',
                'pricing_model',
                'adjusted_pricing_rate',
                'investment_to_date',
                'impressions',
                'clicks',
                'ctr',
                'delivery_percent',
                'remaining_impressions',
                'remaining_budget',
                'ias_total_tracked_ads',
                'ias_eligible_ivt_ads',
                'ias_valid_traffic',
                'ias_ivt_free_rate',
                'ias_measured_ads',
                'ias_viewable_impressions',
                'ias_viewability',
                'ias_passed_ads',
                'ias_eligible_ads_brand_safety',
                'ias_brand_safety_rate',
                'ias_brand_suitability_failed_ads',
                'ias_brand_suitability_rate',
              ],
              column_labels: null,
              sort_by: null,
              sort_ascending: null,
            },
            {
              section_name: 'Line Item Daily Totals',
              section_type: 'Third Party',
              partition_by_io: true,
              include_subtotals: true,
              columns: [
                'io_name',
                'media_type',
                'report_day',
                'investment_to_date',
                'impressions',
                'clicks',
                'ctr',
                'delivery_percent',
                'ias_total_tracked_ads',
                'ias_eligible_ivt_ads',
                'ias_valid_traffic',
                'ias_ivt_free_rate',
                'ias_measured_ads',
                'ias_viewable_impressions',
                'ias_viewability',
                'ias_passed_ads',
                'ias_eligible_ads_brand_safety',
                'ias_brand_safety_rate',
                'ias_brand_suitability_failed_ads',
                'ias_brand_suitability_rate',
              ],
              column_labels: null,
              sort_by: null,
              sort_ascending: null,
            },
          ],
        },
        {
          sheet_name: 'Creatives',
          report_sections: [
            {
              section_name: 'Creative Totals',
              section_type: 'First Party',
              partition_by_io: false,
              include_subtotals: true,
              columns: ['creative_name', 'creative_size', 'investment_to_date', 'impressions', 'clicks', 'ctr'],
              column_labels: null,
              sort_by: null,
              sort_ascending: null,
            },
            {
              section_name: 'Creative Totals by Line Item',
              section_type: 'First Party',
              partition_by_io: true,
              include_subtotals: true,
              columns: [
                'io_name',
                'media_type',
                'creative_name',
                'creative_size',
                'investment_to_date',
                'impressions',
                'clicks',
                'ctr',
              ],
              column_labels: null,
              sort_by: null,
              sort_ascending: null,
            },
          ],
        },
      ],
    },
  },
  {
    report_template: {
      template_id: 6,
      report_name: 'Standard Report (DoubleVerify)',
      ventura_contract_ids: [],
      include_header: true,
      include_footer: true,
      include_logo: true,
      include_glossary: true,
      sheet_objects: [
        {
          sheet_name: 'Summary',
          report_sections: [
            {
              section_name: 'Campaign Basics',
              section_type: 'First Party',
              partition_by_io: false,
              include_subtotals: false,
              columns: [
                'contract_name',
                'contract_start_date',
                'contract_end_date',
                'contract_days_left',
                'contract_imp_budget',
                'contract_dollar_budget',
              ],
              column_labels: null,
              sort_by: null,
              sort_ascending: null,
            },
            {
              section_name: 'Media Basics',
              section_type: 'Media Type',
              partition_by_io: false,
              include_subtotals: false,
              columns: [
                'media_type',
                'pricing_model',
                'pricing_rate',
                'total_impression_budget',
                'total_dollar_budget',
              ],
              column_labels: null,
              sort_by: null,
              sort_ascending: null,
            },
            {
              section_name: 'Delivery (Media Type)',
              section_type: 'Media Type',
              partition_by_io: false,
              include_subtotals: false,
              columns: [
                'media_type',
                'impressions',
                'clicks',
                'ctr',
                'investment_to_date',
                'delivery_percent',
                'remaining_impressions',
                'remaining_budget',
                'dv_monitored_ads',
                'dv_fraud_sivt_free_ads',
                'dv_fraud_free_percent',
                'dv_measured_impressions',
                'dv_viewable_impressions',
                'dv_viewability_rate',
                'dv_brand_safe_ads',
                'dv_brand_safe_percent',
                'dv_brand_suitable_ads',
                'dv_brand_suitability_percent',
                'dv_groupm_billable_impressions',
              ],
              column_labels: null,
              sort_by: null,
              sort_ascending: null,
            },
            {
              section_name: 'Campaign Monthly Totals',
              section_type: 'Third Party',
              partition_by_io: false,
              include_subtotals: true,
              columns: [
                'report_month',
                'investment_to_date',
                'impressions',
                'clicks',
                'ctr',
                'delivery_percent',
                'dv_monitored_ads',
                'dv_fraud_sivt_free_ads',
                'dv_fraud_free_percent',
                'dv_measured_impressions',
                'dv_viewable_impressions',
                'dv_viewability_rate',
                'dv_brand_safe_ads',
                'dv_brand_safe_percent',
                'dv_brand_suitable_ads',
                'dv_brand_suitability_percent',
                'dv_groupm_billable_impressions',
              ],
              column_labels: null,
              sort_by: null,
              sort_ascending: null,
            },
          ],
        },
        {
          sheet_name: 'Monthly Performance',
          report_sections: [
            {
              section_name: 'Line Item Totals',
              section_type: 'Third Party',
              partition_by_io: false,
              include_subtotals: true,
              columns: [
                'io_name',
                'media_type',
                'io_start_date',
                'io_end_date',
                'io_days_left',
                'io_imp_budget',
                'io_dollar_budget',
                'pricing_model',
                'adjusted_pricing_rate',
                'investment_to_date',
                'impressions',
                'clicks',
                'ctr',
                'delivery_percent',
                'remaining_impressions',
                'remaining_budget',
                'dv_monitored_ads',
                'dv_fraud_sivt_free_ads',
                'dv_fraud_free_percent',
                'dv_measured_impressions',
                'dv_viewable_impressions',
                'dv_viewability_rate',
                'dv_brand_safe_ads',
                'dv_brand_safe_percent',
                'dv_brand_suitable_ads',
                'dv_brand_suitability_percent',
                'dv_groupm_billable_impressions',
              ],
              column_labels: null,
              sort_by: null,
              sort_ascending: null,
            },
            {
              section_name: 'Line Item Monthly Totals',
              section_type: 'Third Party',
              partition_by_io: true,
              include_subtotals: true,
              columns: [
                'io_name',
                'media_type',
                'report_month',
                'investment_to_date',
                'impressions',
                'clicks',
                'ctr',
                'delivery_percent',
                'dv_monitored_ads',
                'dv_fraud_sivt_free_ads',
                'dv_fraud_free_percent',
                'dv_measured_impressions',
                'dv_viewable_impressions',
                'dv_viewability_rate',
                'dv_brand_safe_ads',
                'dv_brand_safe_percent',
                'dv_brand_suitable_ads',
                'dv_brand_suitability_percent',
                'dv_groupm_billable_impressions',
              ],
              column_labels: null,
              sort_by: null,
              sort_ascending: null,
            },
          ],
        },
        {
          sheet_name: 'Daily Performance',
          report_sections: [
            {
              section_name: 'Line Item Totals',
              section_type: 'Third Party',
              partition_by_io: false,
              include_subtotals: true,
              columns: [
                'io_name',
                'media_type',
                'io_start_date',
                'io_end_date',
                'io_days_left',
                'io_imp_budget',
                'io_dollar_budget',
                'pricing_model',
                'adjusted_pricing_rate',
                'investment_to_date',
                'impressions',
                'clicks',
                'ctr',
                'delivery_percent',
                'remaining_impressions',
                'remaining_budget',
                'dv_monitored_ads',
                'dv_fraud_sivt_free_ads',
                'dv_fraud_free_percent',
                'dv_measured_impressions',
                'dv_viewable_impressions',
                'dv_viewability_rate',
                'dv_brand_safe_ads',
                'dv_brand_safe_percent',
                'dv_brand_suitable_ads',
                'dv_brand_suitability_percent',
                'dv_groupm_billable_impressions',
              ],
              column_labels: null,
              sort_by: null,
              sort_ascending: null,
            },
            {
              section_name: 'Line Item Daily Totals',
              section_type: 'Third Party',
              partition_by_io: true,
              include_subtotals: true,
              columns: [
                'io_name',
                'media_type',
                'report_day',
                'investment_to_date',
                'impressions',
                'clicks',
                'ctr',
                'delivery_percent',
                'dv_monitored_ads',
                'dv_fraud_sivt_free_ads',
                'dv_fraud_free_percent',
                'dv_measured_impressions',
                'dv_viewable_impressions',
                'dv_viewability_rate',
                'dv_brand_safe_ads',
                'dv_brand_safe_percent',
                'dv_brand_suitable_ads',
                'dv_brand_suitability_percent',
                'dv_groupm_billable_impressions',
              ],
              column_labels: null,
              sort_by: null,
              sort_ascending: null,
            },
          ],
        },
        {
          sheet_name: 'Creatives',
          report_sections: [
            {
              section_name: 'Creative Totals',
              section_type: 'First Party',
              partition_by_io: false,
              include_subtotals: true,
              columns: ['creative_name', 'creative_size', 'investment_to_date', 'impressions', 'clicks', 'ctr'],
              column_labels: null,
              sort_by: null,
              sort_ascending: null,
            },
            {
              section_name: 'Creative Totals by Line Item',
              section_type: 'First Party',
              partition_by_io: true,
              include_subtotals: true,
              columns: [
                'io_name',
                'media_type',
                'creative_name',
                'creative_size',
                'investment_to_date',
                'impressions',
                'clicks',
                'ctr',
              ],
              column_labels: null,
              sort_by: null,
              sort_ascending: null,
            },
          ],
        },
      ],
    },
  },
  {
    report_template: {
      template_id: 7,
      report_name: 'Standard Report (Flastalking)',
      ventura_contract_ids: [],
      include_header: true,
      include_footer: true,
      include_logo: true,
      include_glossary: true,
      sheet_objects: [
        {
          sheet_name: 'Summary',
          report_sections: [
            {
              section_name: 'Campaign Basics',
              section_type: 'First Party',
              partition_by_io: false,
              include_subtotals: false,
              columns: [
                'contract_name',
                'contract_start_date',
                'contract_end_date',
                'contract_days_left',
                'contract_imp_budget',
                'contract_dollar_budget',
              ],
              column_labels: null,
              sort_by: null,
              sort_ascending: null,
            },
            {
              section_name: 'Media Basics',
              section_type: 'Media Type',
              partition_by_io: false,
              include_subtotals: false,
              columns: [
                'media_type',
                'pricing_model',
                'pricing_rate',
                'total_impression_budget',
                'total_dollar_budget',
              ],
              column_labels: null,
              sort_by: null,
              sort_ascending: null,
            },
            {
              section_name: 'Delivery (Media Type)',
              section_type: 'Media Type',
              partition_by_io: false,
              include_subtotals: false,
              columns: [
                'media_type',
                'impressions',
                'clicks',
                'ctr',
                'investment_to_date',
                'delivery_percent',
                'remaining_impressions',
                'remaining_budget',
                'ft_impressions',
                'ft_clicks',
                'ft_ctr',
                'ft_discrepancy',
              ],
              column_labels: null,
              sort_by: null,
              sort_ascending: null,
            },
            {
              section_name: 'Campaign Monthly Totals',
              section_type: 'Third Party',
              partition_by_io: false,
              include_subtotals: true,
              columns: [
                'report_month',
                'investment_to_date',
                'impressions',
                'clicks',
                'ctr',
                'delivery_percent',
                'ft_impressions',
                'ft_clicks',
                'ft_ctr',
                'ft_discrepancy',
              ],
              column_labels: null,
              sort_by: null,
              sort_ascending: null,
            },
          ],
        },
        {
          sheet_name: 'Monthly Performance',
          report_sections: [
            {
              section_name: 'Line Item Totals',
              section_type: 'Third Party',
              partition_by_io: false,
              include_subtotals: true,
              columns: [
                'io_name',
                'media_type',
                'io_start_date',
                'io_end_date',
                'io_days_left',
                'io_imp_budget',
                'io_dollar_budget',
                'pricing_model',
                'adjusted_pricing_rate',
                'investment_to_date',
                'impressions',
                'clicks',
                'ctr',
                'delivery_percent',
                'remaining_impressions',
                'remaining_budget',
                'ft_impressions',
                'ft_clicks',
                'ft_ctr',
                'ft_discrepancy',
              ],
              column_labels: null,
              sort_by: null,
              sort_ascending: null,
            },
            {
              section_name: 'Line Item Monthly Totals',
              section_type: 'Third Party',
              partition_by_io: true,
              include_subtotals: true,
              columns: [
                'io_name',
                'media_type',
                'report_month',
                'investment_to_date',
                'impressions',
                'clicks',
                'ctr',
                'delivery_percent',
                'ft_impressions',
                'ft_clicks',
                'ft_ctr',
                'ft_discrepancy',
              ],
              column_labels: null,
              sort_by: null,
              sort_ascending: null,
            },
          ],
        },
        {
          sheet_name: 'Daily Performance',
          report_sections: [
            {
              section_name: 'Line Item Totals',
              section_type: 'Third Party',
              partition_by_io: false,
              include_subtotals: true,
              columns: [
                'io_name',
                'media_type',
                'io_start_date',
                'io_end_date',
                'io_days_left',
                'io_imp_budget',
                'io_dollar_budget',
                'pricing_model',
                'adjusted_pricing_rate',
                'investment_to_date',
                'impressions',
                'clicks',
                'ctr',
                'delivery_percent',
                'remaining_impressions',
                'remaining_budget',
                'ft_impressions',
                'ft_clicks',
                'ft_ctr',
                'ft_discrepancy',
              ],
              column_labels: null,
              sort_by: null,
              sort_ascending: null,
            },
            {
              section_name: 'Line Item Daily Totals',
              section_type: 'Third Party',
              partition_by_io: true,
              include_subtotals: true,
              columns: [
                'io_name',
                'media_type',
                'report_day',
                'investment_to_date',
                'impressions',
                'clicks',
                'ctr',
                'delivery_percent',
                'ft_impressions',
                'ft_clicks',
                'ft_ctr',
                'ft_discrepancy',
              ],
              column_labels: null,
              sort_by: null,
              sort_ascending: null,
            },
          ],
        },
        {
          sheet_name: 'Creatives',
          report_sections: [
            {
              section_name: 'Creative Totals',
              section_type: 'First Party',
              partition_by_io: false,
              include_subtotals: true,
              columns: ['creative_name', 'creative_size', 'investment_to_date', 'impressions', 'clicks', 'ctr'],
              column_labels: null,
              sort_by: null,
              sort_ascending: null,
            },
            {
              section_name: 'Creative Totals by Line Item',
              section_type: 'First Party',
              partition_by_io: true,
              include_subtotals: true,
              columns: [
                'io_name',
                'media_type',
                'creative_name',
                'creative_size',
                'investment_to_date',
                'impressions',
                'clicks',
                'ctr',
              ],
              column_labels: null,
              sort_by: null,
              sort_ascending: null,
            },
          ],
        },
      ],
    },
  },
  {
    report_template: {
      template_id: 8,
      report_name: 'Standard Report (Innovid)',
      ventura_contract_ids: [],
      include_header: true,
      include_footer: true,
      include_logo: true,
      include_glossary: true,
      sheet_objects: [
        {
          sheet_name: 'Summary',
          report_sections: [
            {
              section_name: 'Campaign Basics',
              section_type: 'First Party',
              partition_by_io: false,
              include_subtotals: false,
              columns: [
                'contract_name',
                'contract_start_date',
                'contract_end_date',
                'contract_days_left',
                'contract_imp_budget',
                'contract_dollar_budget',
              ],
              column_labels: null,
              sort_by: null,
              sort_ascending: null,
            },
            {
              section_name: 'Media Basics',
              section_type: 'Media Type',
              partition_by_io: false,
              include_subtotals: false,
              columns: [
                'media_type',
                'pricing_model',
                'pricing_rate',
                'total_impression_budget',
                'total_dollar_budget',
              ],
              column_labels: null,
              sort_by: null,
              sort_ascending: null,
            },
            {
              section_name: 'Delivery (Media Type)',
              section_type: 'Media Type',
              partition_by_io: false,
              include_subtotals: false,
              columns: [
                'media_type',
                'impressions',
                'clicks',
                'ctr',
                'investment_to_date',
                'delivery_percent',
                'remaining_impressions',
                'remaining_budget',
                'innovid_impressions',
                'innovid_clicks',
                'innovid_ctr',
                'innovid_ctr_discrepancy',
                'innovid_discrepancy',
              ],
              column_labels: null,
              sort_by: null,
              sort_ascending: null,
            },
            {
              section_name: 'Campaign Monthly Totals',
              section_type: 'Third Party',
              partition_by_io: false,
              include_subtotals: true,
              columns: [
                'report_month',
                'investment_to_date',
                'impressions',
                'clicks',
                'ctr',
                'delivery_percent',
                'innovid_impressions',
                'innovid_clicks',
                'innovid_ctr',
                'innovid_ctr_discrepancy',
                'innovid_discrepancy',
              ],
              column_labels: null,
              sort_by: null,
              sort_ascending: null,
            },
          ],
        },
        {
          sheet_name: 'Monthly Performance',
          report_sections: [
            {
              section_name: 'Line Item Totals',
              section_type: 'Third Party',
              partition_by_io: false,
              include_subtotals: true,
              columns: [
                'io_name',
                'media_type',
                'io_start_date',
                'io_end_date',
                'io_days_left',
                'io_imp_budget',
                'io_dollar_budget',
                'pricing_model',
                'adjusted_pricing_rate',
                'investment_to_date',
                'impressions',
                'clicks',
                'ctr',
                'delivery_percent',
                'remaining_impressions',
                'remaining_budget',
                'innovid_impressions',
                'innovid_clicks',
                'innovid_ctr',
                'innovid_ctr_discrepancy',
                'innovid_discrepancy',
              ],
              column_labels: null,
              sort_by: null,
              sort_ascending: null,
            },
            {
              section_name: 'Line Item Monthly Totals',
              section_type: 'Third Party',
              partition_by_io: true,
              include_subtotals: true,
              columns: [
                'io_name',
                'media_type',
                'report_month',
                'investment_to_date',
                'impressions',
                'clicks',
                'ctr',
                'delivery_percent',
                'innovid_impressions',
                'innovid_clicks',
                'innovid_ctr',
                'innovid_ctr_discrepancy',
                'innovid_discrepancy',
              ],
              column_labels: null,
              sort_by: null,
              sort_ascending: null,
            },
          ],
        },
        {
          sheet_name: 'Daily Performance',
          report_sections: [
            {
              section_name: 'Line Item Totals',
              section_type: 'Third Party',
              partition_by_io: false,
              include_subtotals: true,
              columns: [
                'io_name',
                'media_type',
                'io_start_date',
                'io_end_date',
                'io_days_left',
                'io_imp_budget',
                'io_dollar_budget',
                'pricing_model',
                'adjusted_pricing_rate',
                'investment_to_date',
                'impressions',
                'clicks',
                'ctr',
                'delivery_percent',
                'remaining_impressions',
                'remaining_budget',
                'innovid_impressions',
                'innovid_clicks',
                'innovid_ctr',
                'innovid_ctr_discrepancy',
                'innovid_discrepancy',
              ],
              column_labels: null,
              sort_by: null,
              sort_ascending: null,
            },
            {
              section_name: 'Line Item Daily Totals',
              section_type: 'Third Party',
              partition_by_io: true,
              include_subtotals: true,
              columns: [
                'io_name',
                'media_type',
                'report_day',
                'investment_to_date',
                'impressions',
                'clicks',
                'ctr',
                'delivery_percent',
                'innovid_impressions',
                'innovid_clicks',
                'innovid_ctr',
                'innovid_ctr_discrepancy',
                'innovid_discrepancy',
              ],
              column_labels: null,
              sort_by: null,
              sort_ascending: null,
            },
          ],
        },
        {
          sheet_name: 'Creatives',
          report_sections: [
            {
              section_name: 'Creative Totals',
              section_type: 'First Party',
              partition_by_io: false,
              include_subtotals: true,
              columns: ['creative_name', 'creative_size', 'investment_to_date', 'impressions', 'clicks', 'ctr'],
              column_labels: null,
              sort_by: null,
              sort_ascending: null,
            },
            {
              section_name: 'Creative Totals by Line Item',
              section_type: 'First Party',
              partition_by_io: true,
              include_subtotals: true,
              columns: [
                'io_name',
                'media_type',
                'creative_name',
                'creative_size',
                'investment_to_date',
                'impressions',
                'clicks',
                'ctr',
              ],
              column_labels: null,
              sort_by: null,
              sort_ascending: null,
            },
          ],
        },
      ],
    },
  },
];

const reportTemplateDefaultList = reportTemplateDefaultListRaw.map((template) => camelCaseKeys(template));

export default reportTemplateDefaultList;
